import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetEnglishIqDemoV1Response } from './get-english-iq-demo-v1-response';
import { getEnglishIqDemoV1ResponseSchema } from './get-english-iq-demo-v1-response';

export async function getEnglishIqDemoV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetEnglishIqDemoV1Response>> {
  return getRequest<IGetEnglishIqDemoV1Response>({
    options,
    path: '/sys/english-iq/demo/v1',
    schema: getEnglishIqDemoV1ResponseSchema,
  });
}
